var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Grid", {
    staticClass: "fit",
    attrs: {
      id: "documentGrid",
      module: _vm.module,
      data: _vm.documentList,
      pagination: _vm.pagination,
      columns: _vm.columnOptions,
      loading: _vm.loadingData,
      onDownload: _vm.select,
      shouldShowRead: _vm.isKennyHuangOrAdmin
        ? _vm.shouldShowRead
        : function() {
            return false
          },
      onRead: _vm.read,
      onRequest: _vm.onFetch,
      filterable: _vm.filterable,
      onDelete: _vm.onRemove
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }